import React from 'react'
import { useKnockStatusIcons } from './hooks'

const DEFAULT_COLOR = '#D63B1F'
const DEFAULT_WIDTH = 52
const DEFAULT_HEIGHT = 56
const DEFAULT_VIEW_BOX = '10 5 50 40'

type Props = {
  color?: string
  icon: number | null
  width?: number
  height?: number
  baseIconSize?: number
  viewBox?: string
  isPreview?: boolean
}

export function KnockStatusIcon(props: Props) {
  const {
    color = DEFAULT_COLOR,
    icon,
    width = DEFAULT_WIDTH,
    height = DEFAULT_HEIGHT,
    viewBox = DEFAULT_VIEW_BOX,
    isPreview = false,
  } = props
  const { getIcon } = useKnockStatusIcons()

  const BaseIcon = getIcon(icon, 'white', '20px')

  // Calculate the center circle area for the base icon
  // with a radius of about 14.5 units
  const circleCenterX = 25.43
  const circleCenterY = 24.5
  const iconAreaSize = 20 // Size of the area for the base icon in viewBox units

  // Calculate foreignObject position (centered on the circle)
  const foreignX = circleCenterX - iconAreaSize / 2
  const foreignY = circleCenterY - iconAreaSize / 2

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      role="img"
      aria-label="D2D Status Icon"
    >
      {/* Bottom pointer triangle */}
      <path
        d="M20.2539 35.0234H27.8414L27.0826 40.3347L25.5651 42.6109L20.2539 35.0234Z"
        fill={color}
      />

      {/* Main circular shape */}
      <path
        d="M39.9807 24.5607C39.9807 32.1035 33.5264 39.7356 25.5646 39.7356C17.6028 39.7356 11.1484 32.1035 11.1484 24.5607C11.1484 17.0179 17.6028 10.1445 25.5646 10.1445C33.5264 10.1445 39.9807 17.0179 39.9807 24.5607Z"
        fill={color}
      />

      {/* Outer border */}
      {isPreview ? (
        <path
          d="M24.8407 44.1536C24.9034 44.2585 24.9926 44.3449 25.0994 44.4042C25.2063 44.4635 25.3269 44.4935 25.449 44.4913C25.5712 44.489 25.6905 44.4545 25.7951 44.3912C25.8996 44.328 25.9855 44.2382 26.0442 44.1311L28.4086 39.8204C31.5899 39.2474 34.5088 37.6843 36.749 35.354C38.8856 33.1388 40.317 30.3395 40.862 27.3104C41.407 24.2813 41.0411 21.1586 39.8107 18.3376C38.5802 15.5165 36.5405 13.1239 33.9497 11.4626C31.3589 9.80122 28.3334 8.94583 25.2563 9.00466C22.1791 9.06349 19.1886 10.0339 16.6632 11.793C14.1377 13.5522 12.191 16.021 11.0692 18.887C9.9475 21.7531 9.70125 24.8875 10.3616 27.8935C11.022 30.8995 12.5593 33.6421 14.779 35.7741C16.8261 37.7567 19.3918 39.1207 22.1803 39.7088L24.8407 44.1536ZM15.7411 34.7745C13.7191 32.8328 12.3185 30.3348 11.7168 27.5968C11.115 24.8588 11.3391 22.0038 12.3607 19.3932C13.3823 16.7826 15.1554 14.5337 17.4557 12.9313C19.756 11.3289 22.4799 10.445 25.2828 10.3914C28.0856 10.3378 30.8414 11.117 33.2012 12.6303C35.561 14.1436 37.4188 16.323 38.5395 18.8927C39.6601 21.4623 39.9932 24.3067 39.4965 27.0657C38.9998 29.8247 37.6958 32.3744 35.7494 34.3919C33.6355 36.5889 30.8615 38.0347 27.8498 38.5092C27.7457 38.5262 27.6468 38.5666 27.5607 38.6274C27.4745 38.6882 27.4033 38.7679 27.3525 38.8603L25.4097 42.4029L23.2125 38.7321C23.1621 38.6477 23.0943 38.5751 23.0137 38.5189C22.9331 38.4627 22.8415 38.4242 22.7449 38.4061C20.1053 37.9069 17.6701 36.6442 15.7411 34.7745Z"
          fill="white"
        />
      ) : (
        <g filter="url(#filter0_ddd_3405_11112)">
          <path
            d="M24.8407 44.1536C24.9034 44.2585 24.9926 44.3449 25.0994 44.4042C25.2063 44.4635 25.3269 44.4935 25.449 44.4913C25.5712 44.489 25.6905 44.4545 25.7951 44.3912C25.8996 44.328 25.9855 44.2382 26.0442 44.1311L28.4086 39.8204C31.5899 39.2474 34.5088 37.6843 36.749 35.354C38.8856 33.1388 40.317 30.3395 40.862 27.3104C41.407 24.2813 41.0411 21.1586 39.8107 18.3376C38.5802 15.5165 36.5405 13.1239 33.9497 11.4626C31.3589 9.80122 28.3334 8.94583 25.2563 9.00466C22.1791 9.06349 19.1886 10.0339 16.6632 11.793C14.1377 13.5522 12.191 16.021 11.0692 18.887C9.9475 21.7531 9.70125 24.8875 10.3616 27.8935C11.022 30.8995 12.5593 33.6421 14.779 35.7741C16.8261 37.7567 19.3918 39.1207 22.1803 39.7088L24.8407 44.1536ZM15.7411 34.7745C13.7191 32.8328 12.3185 30.3348 11.7168 27.5968C11.115 24.8588 11.3391 22.0038 12.3607 19.3932C13.3823 16.7826 15.1554 14.5337 17.4557 12.9313C19.756 11.3289 22.4799 10.445 25.2828 10.3914C28.0856 10.3378 30.8414 11.117 33.2012 12.6303C35.561 14.1436 37.4188 16.323 38.5395 18.8927C39.6601 21.4623 39.9932 24.3067 39.4965 27.0657C38.9998 29.8247 37.6958 32.3744 35.7494 34.3919C33.6355 36.5889 30.8615 38.0347 27.8498 38.5092C27.7457 38.5262 27.6468 38.5666 27.5607 38.6274C27.4745 38.6882 27.4033 38.7679 27.3525 38.8603L25.4097 42.4029L23.2125 38.7321C23.1621 38.6477 23.0943 38.5751 23.0137 38.5189C22.9331 38.4627 22.8415 38.4242 22.7449 38.4061C20.1053 37.9069 17.6701 36.6442 15.7411 34.7745Z"
            fill="white"
          />
        </g>
      )}

      {/* Base icon - positioned in the center */}
      {BaseIcon && (
        <svg
          x={foreignX}
          y={foreignY}
          width={iconAreaSize}
          height={iconAreaSize}
        >
          {BaseIcon}
        </svg>
      )}

      <defs>
        <filter
          id="filter0_ddd_3405_11112"
          x="0"
          y="0"
          width="51.1074"
          height="55.4922"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_3405_11112"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.054902 0 0 0 0 0.156863 0 0 0 0 0.247059 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3405_11112"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.054902 0 0 0 0 0.156863 0 0 0 0 0.247059 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_3405_11112"
            result="effect2_dropShadow_3405_11112"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.054902 0 0 0 0 0.156863 0 0 0 0 0.247059 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_3405_11112"
            result="effect3_dropShadow_3405_11112"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_3405_11112"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
